import React from 'react'
import styles from './IconButton.module.scss'
import { Icon as IconHandler } from 'components'

interface Props {
  icon: string | React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  svgProps?: React.SVGProps<SVGSVGElement>;
  title?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  disabled?: boolean;
}

const IconButton = (props: Props) => {
  const {
    icon: Icon,
    svgProps = {},
    className = '',
    onClick,
    type = 'button',
    children,
    disabled,
    ...rest
  } = props
  const styling = [styles.buttonReset, className]
  disabled && styling.push(styles.disabled)

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (disabled) return
    onClick && onClick()
  }

  return (
    <button
      className={styling.join(' ')}
      onClick={handleClick}
      type={type}
      {...rest}
    >
      {typeof Icon === 'string'
        ? <IconHandler icon={Icon} />
        : <Icon {...svgProps} />
      } {children}
    </button>
  )
}

export default IconButton
